import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Link } from '@calendly/ui/components/link';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useBillingPath } from 'features/billing';
const styledContactUsButtonCss = "s17g7h1d";
const StyledContactUsButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledContactUsButtonCss, props.className)} />);
const HelpCenterLink = ({
  children
}) => <Link href="https://calendly.com/help/how-to-add-legal-disclaimers-to-text-notifications" target="_blank" rel="noopener noreferrer">
    {children}
  </Link>;
export const SMSLegalDisclaimerPaywall = ({
  wrapperComponent = 'div',
  headingTextComponent = HeadingText,
  bodyTextComponent = BodyText
}) => {
  const WrapperComponent = wrapperComponent;
  const HeadingTextComponent = headingTextComponent;
  const BodyTextComponent = bodyTextComponent;
  const contactSalesPath = useBillingPath('/contact_sales', {
    interest: 'SMSdisclaimer'
  });
  return <WrapperComponent data-component="sms-legal-disclaimer-paywall">
      <HeadingTextComponent level={2}>{I18n.t('publisher.organization.branding.sms_legal_disclaimer.label')}</HeadingTextComponent>
      <BodyTextComponent>{I18n.t('publisher.organization.branding.sms_legal_disclaimer.description')}</BodyTextComponent>
      <BodyTextComponent>
        {HtmlParser(I18n.t('publisher.organization.branding.sms_legal_disclaimer.paywall.learn_more'), {
        HelpCenterLink
      })}
      </BodyTextComponent>
      <StyledContactUsButton as={RouterLink} to={contactSalesPath}>
        {I18n.t('publisher.billing.contact_sales.contact_us')}
      </StyledContactUsButton>
    </WrapperComponent>;
};

require("./sms_legal_disclaimer.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sms_legal_disclaimer.js");